module.exports = __webpack_public_path__ + "img/apple-and-blackberry-oat-crumble.bf26d0e5.jpg";